import React, { useEffect } from 'react';
import { LuPhone } from 'react-icons/lu';
import MarketingImg from '../../Images/MarketingImg.webp';

function Marketing() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <div className="mt-16 md:mt-10 bg-gradient-to-br from-slate-50 to-slate-100 min-h-screen flex flex-col items-center justify-center p-4">
            <div className="text-center mb-12">
                <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text 
        bg-gradient-to-r from-[#e2228c] to-[#7b45ef] mb-4 pb-2">
                    Marketing
                </h1>
                <p className="text-lg md:text-xl text-black max-w-2xl mx-auto">
                    Transform your business with Tailored Marketing Plans for Your Success
                </p>
            </div>

            <div className="max-w-4xl w-full bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row">
                {/* Profile Section */}
                <div className="md:w-1/3 bg-gradient-to-b from-[#e2228c] to-[#7b45ef] text-white p-8 flex flex-col items-center justify-center">
                    <div className="relative mb-6">
                        <img
                            src={MarketingImg}
                            alt="Professional Portrait"
                            className="w-32 h-32 md:w-48 md:h-48 rounded-full border-6 border-white shadow-2xl object-cover 
                            transform transition-transform duration-300 hover:scale-105"
                        />
                    </div>
                    <h2 className="text-xl md:text-2xl font-bold mb-2 text-center tracking-wide">Rajnish Dutta</h2>
                    <p className="text-sm text-black p-2 bg-white/70 rounded-full text-center">
                        Marketing and Editing Head
                    </p>
                </div>

                {/* Content Section */}
                <div className="md:w-2/3 p-6 md:p-8 flex flex-col justify-between">
                    <div>
                        <p className="text-base md:text-lg text-black mb-6 leading-relaxed">
                            Experienced strategic marketing expert with a proven track record of driving transformational change for multiple organizations. Specializing in digital strategy, operational optimization, and innovative business solutions.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                            <div className="bg-[#e2228c]/15 p-4 rounded-lg hover:bg-[#e2228c]/30 transition-colors group">
                                <h3 className="font-semibold text-[#e2228c] mb-2 group-hover:text-opacity-80 transition-colors">
                                    Expertise
                                </h3>
                                <ul className="text-black space-y-1">
                                    <li>Digital Transformation</li>
                                    <li>Business Strategy</li>
                                    <li>Operational Excellence</li>
                                </ul>
                            </div>
                            <div className="bg-[#7b45ef]/15 p-4 rounded-lg hover:bg-[#7b45ef]/30 transition-colors group">
                                <h3 className="font-semibold text-[#7b45ef] mb-2 group-hover:text-opacity-80 transition-colors">
                                    Achievements
                                </h3>
                                <ul className="text-black space-y-1">
                                    <li>20+ Projects</li>
                                    <li>Founder @ Candymenzfilms</li>
                                    <li>Video Editor @ CFB Academy</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <a href="https://calendly.com/lahejp7/30min" target='blank'>
                        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                            <button className="flex-1 flex items-center justify-center bg-[#7b45ef] text-white py-3 rounded-lg 
                                                hover:bg-[#7b45ef]/90 transition-all transform hover:-translate-y-1 hover:shadow-xl group">
                                <LuPhone className="mr-2 group-hover:rotate-12 transition-transform" />
                                Book Consultation
                            </ button>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Marketing;